import type {
    VirtualAppointmentCancellation,
    VirtualAppointmentCancellationKind,
    VirtualAppointmentStatus
} from '../../../services/virtualAppointments';
import { MISSING_VALUE } from './missingValue.ts';

export interface ClosureLabels {
    date: string;
    by: string;
    /** Only a canceled VA explains why it closed. */
    reason?: string;
}

const CLOSURE_LABELS: Partial<Record<VirtualAppointmentStatus, ClosureLabels>> = {
    done: { date: 'Resolved', by: 'Resolved by' },
    canceled: { date: 'Canceled', by: 'Canceled by', reason: 'Reason' }
};

// Null while the VA is still live, which hides the closing date and who closed it.
export function closureLabels(status: VirtualAppointmentStatus): ClosureLabels | null {
    return CLOSURE_LABELS[status] ?? null;
}

// A staff cancel shows the author's own words; system cancels have no reason text.
const SYSTEM_CANCELLATION_TEXT: Record<
    Exclude<VirtualAppointmentCancellationKind, 'staff'>,
    string
> = {
    superseded_by_rdi: 'Superseded by a new RDI',
    document_invalidated: 'Source document deleted'
};

export function cancellationReasonText(
    cancellation: VirtualAppointmentCancellation | null
): string {
    if (!cancellation) return MISSING_VALUE;
    if (cancellation.kind !== 'staff') return SYSTEM_CANCELLATION_TEXT[cancellation.kind];
    return cancellation.reason?.trim() || MISSING_VALUE;
}
